/**
 * Licence-allocation Graph calls (C11). Reads each user's assigned licences and the
 * tenant's purchased SKUs / service plans, behind the graph/ layer. Least-privilege,
 * zero-egress. Endpoints are recorded for provenance.
 */
import { graphGetAll } from '@/graph/client';
import { CAPABILITY_SCOPES } from '@/auth/scopes';
import type { SubscribedSku } from '@/graph/types';

const SCOPES = CAPABILITY_SCOPES.C11.scopes;

export const LICENSE_ENDPOINTS = {
  users: '/users',
  subscribedSkus: '/subscribedSkus',
} as const;

export interface AssignedLicense {
  skuId?: string | null;
  disabledPlans?: string[];
}

export interface LicensedUser {
  id: string;
  displayName: string | null;
  userPrincipalName: string | null;
  assignedLicenses?: AssignedLicense[];
}

/** Users that hold at least one licence. */
export function getLicensedUsers(): Promise<LicensedUser[]> {
  return graphGetAll<LicensedUser>(LICENSE_ENDPOINTS.users, {
    scopes: SCOPES,
    query: {
      $select: 'id,displayName,userPrincipalName,assignedLicenses',
      $top: '999',
    },
  });
}

/** Tenant SKUs + their service plans (reused shape from C2). */
export function getSubscribedSkusForLicensing(): Promise<SubscribedSku[]> {
  return graphGetAll<SubscribedSku>(LICENSE_ENDPOINTS.subscribedSkus, { scopes: SCOPES });
}
